import { render } from "./paySucces.vue?vue&type=template&id=506ad988&scoped=true"
import script from "./paySucces.vue?vue&type=script&lang=js"
export * from "./paySucces.vue?vue&type=script&lang=js"

import "./paySucces.vue?vue&type=style&index=0&id=506ad988&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-506ad988"]])

export default __exports__